<template>
  <div class="carrier-list-data">
    <div class="more-contain align between">
      <span class="now-monitor">
        已监控 {{ $_.get(info, 'data.barrage.value') }} 位，您还可以监控
        {{ $_.get(info, 'data.barrage.limit') - $_.get(info, 'data.barrage.value') }} 位达人
      </span>
      <router-link to="/search" class="button">添加</router-link>
    </div>
    <router-link
      :to="`/anchor/${$_.get(item, 'anchor.id')}?banner=2`"
      v-for="(item, index) in $_.get(info, 'data.subscription', [])"
      :key="item.anchorId"
      class="item-default"
    >
      <div class="commodity-sort">{{ index + 1 }}</div>
      <div class="item-icon icon-radius">
        <img :src="$_.get(item, 'anchor.avatar')" alt="头像" />
      </div>
      <div class="center-anchor-goods">
        <div class="item-name">{{ $_.get(item, 'anchor.name') }}</div>
        <div class="item-fans">粉丝数：{{ $retainWan($_.get(item, 'anchor.fans')) }}</div>
        <div class="item-tag-contain">
          <div class="default-tag" v-for="tag of item.ecommerceTag" :key="tag">
            {{ tag }}
          </div>
        </div>
      </div>
      <div class="data-for-detail">
        <div class="data-title">最近直播</div>
        <div class="data-number data-number-red">
          {{ $formatTime(item.latestLivingTime * 1000, 'MM-DD HH:mm') }}
        </div>
        <div class="data-title data-title-sec">已监控场次</div>
        <div class="data-number">{{ $retainWan(item.session) }}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: { info: Object }
};
</script>

<style lang="less" scoped>
.more-contain {
  height: 1rem;
  padding: 0 0.3rem;
  background: #fff;
  margin-bottom: 0.1rem;

  .now-monitor {
    color: #a1aebf;
    font-size: 0.28rem;
    line-height: 1rem;
  }

  .button {
    color: #ff9900;
    padding: 0 0.3rem;
    height: 0.6rem;
    line-height: 0.6rem;
    border-radius: 0.3rem;
    border: 0.02rem solid #ff9900;
  }
}
</style>
